// extracted by mini-css-extract-plugin
module.exports = {"expandButton":"expand_button_expandButton__1FF01","arrowIcon":"expand_button_arrowIcon__3Itsx","arrowIconInverted":"expand_button_arrowIconInverted__3B1ml"};